import React, { useState, useContext, useEffect } from 'react';
import { PersonContext } from '../../providers/Person';
import requests from '../../utils/requests.js';
import { s } from '../../Style.jsx';
import LabeledInput from '../../common/LabeledInput.jsx';
import AutocompleteAny from '../../common/AutocompleteAny.jsx';
import OrderSummary from '../../common/OrderSummary.jsx';
import DeliveryDetails from '../../common/FullDeliveryDetails.jsx';
import OrderItems from '../../common/OrderItems.jsx';
import OrderNotes from '../../common/OrderNotes.jsx';

const Expanded = ({ resetOrders, setOrders, orders, order, deleteOrder, setViewingOrder, vendors, people, drivers }) => {
    const { auth } = useContext(PersonContext);

    const [editingSummary, setEditingSummary] = useState(false);

    const [settings, setSettings] = useState({});
    useEffect(() => {
        requests.getSettings(auth).then(settings => {
            setSettings(settings);
        });
    }, []);

    const vendor = vendors.find(v => v.id === order.vendorId);

    return <div style={s.mobileContainer}>

        <h2 style={{ marginBottom: 10 }}><s.BackArrow does={() => setViewingOrder(null)} />Order #{order.id}</h2>
        <h3 style={{ marginBottom: 10 }}>Order Status</h3>

        <div style={{ ...s.row }}>
            <LabeledInput label="Customer" onChange={async (e) => {
                setViewingOrder({ ...order, dispatch_status: e });
                await requests.updateOrder({ auth, id: order.id, values: { dispatch_status: e } });
                resetOrders();
            }} value={order.dispatch_status || "pending"} type="select" def={["pending", "accepted", "delivering", "complete"]} labelstyle={{ width: 70, fontSize: 14 }} />
            <AutocompleteAny style={{ input: { width: 120, fontSize: 14 } }} options={people} type="person" selected={order.customerId} onChange={async (person) => {
                setViewingOrder({ ...order, customerId: person.id });
                await requests.updateOrder({ auth, id: order.id, values: { customerId: person.id } });
                resetOrders();
            }} />
        </div>

        <div style={{ ...s.row, marginTop: 10 }}>
            <LabeledInput label="Vendor" onChange={async (e) => {
                setViewingOrder({ ...order, vendor_status: e });
                await requests.updateOrder({ auth, id: order.id, values: { vendor_status: e } });
                resetOrders();
            }} value={order.vendor_status || "pending"} type="select" def={["pending", "accepted", "ready", "complete"]} labelstyle={{ width: 70, fontSize: 14 }} />
            <AutocompleteAny style={{ input: { width: 120, fontSize: 14 } }} options={vendors} selected={order.vendorId} type="vendor" onChange={async (vendor) => {
                setViewingOrder({ ...order, vendorId: vendor.id });
                await requests.updateOrder({ auth, id: order.id, values: { vendorId: vendor.id } });
                resetOrders();
            }} />
        </div>

        <div style={{ ...s.row, marginTop: 10 }}>
            <LabeledInput label="Driver" onChange={async (e) => {
                setViewingOrder({ ...order, driver_status: e });
                await requests.updateOrder({ auth, id: order.id, values: { driver_status: e } });
                resetOrders();
            }
            } value={order.driver_status || "pending"} type="select" def={["pending", "copy", "leaving", "clear"]} labelstyle={{ width: 70, fontSize: 14 }} />
            <AutocompleteAny
                type="driver"
                style={{ input: { width: 120, fontSize: 14 } }}
                options={drivers.filter(driver => driver.reportId || order.driver === driver.id)}
                selected={order.driver}
                onChange={async (driver) => {
                    setViewingOrder({ ...order, driver: driver.id, driverReportId: driver.reportId });
                    await requests.updateOrder({ auth, id: order.id, values: { driver: driver.id } });
                    resetOrders();
                }}
            />
        </div>
        {order.driver && <div style={{ textAlign: "right", width: "100%", fontSize: 12 }}>Report #{order.driverReportId}</div>}

        <DeliveryDetails setViewingOrder={setViewingOrder} setOrders={setOrders} order={order} />

        {(order.images || order.signaturePhoto || order.items) && <h3 style={{ marginBottom: 10 }}>Order Details</h3>}
        <OrderItems order={order} />
        {order.images && order.images.map((image, index) => <img key={index} src={image} style={{ width: "100%", maxWidth: 100, marginBottom: 10 }} />)}
        {order.signaturePhoto && <img src={order.signaturePhoto} style={{ width: "100%", maxWidth: 100, marginBottom: 10 }} />}
        <OrderNotes order={order} />

























        <h3 style={{ marginBottom: 10 }}>Payment Options</h3>
        <div style={{ ...s.box }}>

            <div style={{ ...s.table, marginBottom: 10 }}>
                <div style={{ ...s.cell(0) }}>
                    <span style={{ color: false ? "#fff" : "#000", fontSize: 12 }}>Requesting Stripe Payment?</span>
                    <span style={{ color: false ? "#ffffff80" : "#00000080", fontSize: 12 }}>{order.stripeEnabled ? "Yes" : "No"}</span>
                </div>
                <div style={{ ...s.cell(1) }}>
                    <LabeledInput type="checkbox" label="Enable Stripe Payment" value={order.stripeEnabled} onChange={async (e) => {
                        setViewingOrder({ ...order, stripeEnabled: e });
                        await requests.updateOrder({ auth: auth, id: order.id, values: { stripeEnabled: e } });
                        resetOrders();
                    }
                    } labelstyle={{ color: false ? "#fff" : "#000", fontSize: 12 }} />
                </div>
                <div style={{ ...s.cell(0) }}>
                    <LabeledInput type="checkbox" label="On Account" value={order.onaccount} onChange={async (e) => {
                        setViewingOrder({ ...order, onaccount: e });
                        await requests.updateOrder({ auth: auth, id: order.id, values: { onaccount: e } });
                        resetOrders();
                    }
                    } labelstyle={{ color: false ? "#fff" : "#000", fontSize: 12 }} />
                </div>
                <div style={{ ...s.cell(2) }}>
                    <LabeledInput type="checkbox" label="Subtotal Floated" value={order.subtotalFloated} onChange={async (e) => {
                        setViewingOrder({ ...order, subtotalFloated: e });
                        await requests.updateOrder({ auth: auth, id: order.id, values: { subtotalFloated: e } });
                        resetOrders();
                    }
                    } labelstyle={{ color: false ? "#fff" : "#000", fontSize: 12 }} />
                </div>
            </div>

        </div>

        {!editingSummary && <>

            <OrderSummary order={order} setViewingOrder={setViewingOrder} setOrders={setOrders} resetOrders={resetOrders} />

            <button onClick={() => setEditingSummary(true)} style={{ ...s.button, marginBottom: 10 }}>
                <span style={{  }}>Edit Summary</span>
            </button>

        </>}


        {editingSummary && <>

            <span style={{ marginBottom: 10, fontWeight: "bold", color: false ? "#fff" : "#000", fontSize: 20, marginTop: 10 }}>Order Summary</span>

            <div style={{ ...s.box, padding: 10, marginBottom: 10 }}>
                <div style={{ ...s.table, marginBottom: 10 }}>

                    {order.stripeEnabled && <div style={{ ...s.cell(0) }}>
                        <LabeledInput labelstyle={{ fontSize: 12, flex: 1 }}
                            label="Stripe Fee" type="number" prefix="$" boxstyle={{ ...s.rowCenter }} value={order.stripeFee || 0} onChange={async (e) => {

                                e = parseFloat(e);
                                setViewingOrder({ ...order, stripeFee: e });
                            }} />
                    </div>}

                    <div style={{ ...s.cell(1) }}>
                        <LabeledInput labelstyle={{ fontSize: 12, flex: 1 }}
                            label="Subtotal" type="number" prefix="$" boxstyle={{ ...s.rowCenter }} value={order.subtotal || 0} onChange={async (e) => {

                                e = parseFloat(e);
                                setViewingOrder({ ...order, subtotal: e });
                            }} />
                    </div>
                    <div style={{ ...s.cell(2) }}>
                        <LabeledInput labelstyle={{ fontSize: 12, flex: 1 }}
                            label="Delivery Fee" type="number" prefix="$" boxstyle={{ ...s.rowCenter }} value={order.deliveryFee || 0} onChange={async (e) => {

                                e = parseFloat(e);
                                setViewingOrder({
                                    ...order,
                                    deliveryFee: e,
                                    deliveryFeeTax: (e * (0.13)) || 0,
                                    comission: (typeof order.comissionRate === "numbmer" ? order.comissionRate : vendor.comissionRate || 0) * (e * 1.13),
                                });
                            }} />
                    </div>
                    <div style={{ ...s.cell(3) }}>
                        <LabeledInput labelstyle={{ fontSize: 12, flex: 1 }}
                            label="Delivery Tax" type="number" prefix="$" boxstyle={{ ...s.rowCenter }} value={order.deliveryFeeTax || 0} onChange={async (e) => {

                                e = parseFloat(e);
                                setViewingOrder({
                                    ...order,
                                    deliveryFeeTax: e,
                                    deliveryFee: (e / (0.13)) || 0,
                                    comission: (typeof order.comissionRate === "numbmer" ? order.comissionRate : vendor.comissionRate || 0) * (e / (0.13)) || 0 + e,
                                });
                            }} />
                    </div>
                    <div style={{ ...s.cell(4) }}>
                        <LabeledInput labelstyle={{ fontSize: 12, flex: 1 }}
                            label="Comission Rate" step="1" type="number" prefix="%" boxstyle={{ ...s.rowCenter }}
                            value={order.comissionRate ? order.comissionRate * 100 :
                                //calculate from delivery fee and tax
                                (order.deliveryFee && order.deliveryFeeTax) ?
                                    ((order.comission || 0) / ((order.deliveryFee || 0) + (order.deliveryFeeTax || 0))) * 100 :
                                    (vendor.comissionRate || settings.comissionRate || 0) * 100}
                            onChange={async (e) => {
                                e = parseInt(e);
                                setViewingOrder({
                                    ...order,
                                    comissionRate: !e ? 0 : e / 100,
                                    comission: !e ? 0 : (e / 100) * ((order.deliveryFee || 0) + (order.deliveryFeeTax || 0))
                                });
                            }} />
                    </div>
                    <div style={{ ...s.cell(5) }}>
                        <LabeledInput labelstyle={{ fontSize: 12, flex: 1 }}
                            label="Comission" type="number" prefix="$" boxstyle={{ ...s.rowCenter }} value={order.comission || 0} onChange={async (e) => {

                                e = parseFloat(e);
                                setViewingOrder({
                                    ...order,
                                    comissionRate: (e / ((order.deliveryFee || 0) + (order.deliveryFeeTax || 0))),
                                    comission: e,
                                });
                            }} />
                    </div>

                </div>
                <div style={{ ...s.row }}>
                    <div style={{ flex: 1 }}></div>
                    <button onClick={async () => {
                        setEditingSummary(false);
                        await requests.updateOrder({
                            auth: auth,
                            id: order.id,
                            values: {
                                stripeFee: order.stripeFee,
                                subtotal: order.subtotal,
                                deliveryFee: order.deliveryFee,
                                deliveryFeeTax: order.deliveryFeeTax,
                                comission: order.comission,
                            }
                        });
                        resetOrders();
                    }} style={{ ...s.button, marginBottom: 4, }}>
                        <span style={{  }}>Save</span>
                    </button>
                    <button onClick={() => {
                        setViewingOrder(orders.find(o => o.id === order.id));
                        setEditingSummary(false);
                    }} style={{ ...s.button, marginBottom: 4, backgroundColor: "gray" }}>
                        <span style={{  }}>Cancel</span>
                    </button>
                </div>
            </div>

        </>
        }


        {/* delete */}
        <button onClick={() => {
            // Alert.alert("Delete Order", "Are you sure you want to delete this order?", [
                // { text: "Cancel", style: "cancel" },
                // {
                    // text: "Delete", style: "destructive", onClick: async () => {
                        // setViewingOrder(null);
                        // await requests.deleteOrder(auth, order.id);
                        // resetOrders();
                    // }
                // }
            // ]);
        }} style={{ ...s.button, display: "block", backgroundColor: "red", marginTop: 10 }}>
            <span style={{ color: "white" }}>Delete Order</span>
        </button>



    </div >;

}

export default Expanded;